import React from "react";
import styled from "styled-components";
import {EnhancedLlmRun} from "common/flowmaster/types/llm_run";
import TitleRowTd from "./title_row_td";
import OutputCell from "./output_cell";

interface InputsProps {
  llmRuns: EnhancedLlmRun[];
  inputNames: string[];
  shownInputs: string[];
  setShownInputs: (inputs: string[]) => void;
}

const InputKey = styled.td`
  &:hover {
    cursor: pointer;
  }
`;

export function getInputNameIdMap(
  llmRuns: EnhancedLlmRun[],
  inputs: string[],
): Record<string, number[]> {
  return llmRuns
    .map(({inputs}) => inputs)
    .flat()
    .filter(input => inputs.includes(input.name))
    .reduce((nameIdMap, input) => {
      return {
        ...nameIdMap,
        [input.name]: Array.from(
          new Set([...(nameIdMap[input.name] ?? []), input.id]),
        ),
      };
    }, {});
}

export default function InputRows({
  llmRuns,
  inputNames,
  shownInputs,
  setShownInputs,
}: InputsProps) {
  const inputNameIdMap = getInputNameIdMap(llmRuns, inputNames);

  const hiddenInputs = inputNames.filter(key => !shownInputs.includes(key));
  const keyDisplayOrder = [...shownInputs.sort(), ...hiddenInputs.sort()];

  const handleInputRowClick = inputName => {
    const inputNameIndex = shownInputs.indexOf(inputName);
    if (inputNameIndex === -1) {
      setShownInputs([...shownInputs, inputName]);
    } else {
      setShownInputs(
        shownInputs.filter((item, index) => index !== inputNameIndex),
      );
    }
  };

  return (
    <>
      <tr id="inputs">
        <TitleRowTd>Inputs</TitleRowTd>
        {llmRuns.map(run => (
          <TitleRowTd key={`inputTitleTd${run.id}`}></TitleRowTd>
        ))}
      </tr>
      {keyDisplayOrder.map(name => {
        const nameIds = inputNameIdMap[name];
        const hidden = hiddenInputs.includes(name);
        if (nameIds) {
          return (
            <tr key={`inputs.${name}`} id={`inputs.${name}`}>
              <InputKey
                style={hidden ? {color: "grey"} : {}}
                onClick={() => handleInputRowClick(name)}
              >
                {name}
              </InputKey>
              {llmRuns.map(run => {
                const llmRunInputId = run.inputs.find(input =>
                  nameIds.includes(input.id),
                )?.id;
                const inputValue = llmRunInputId
                  ? run.data.data_store.input[llmRunInputId]
                  : null;
                return (
                  <OutputCell
                    key={`inputs.${name}.${run.id}`}
                    runId={run.id}
                    value={inputValue}
                    testResults={null}
                    hidden={hidden}
                    maxHeight="20em"
                  />
                );
              })}
            </tr>
          );
        } else {
          return <></>;
        }
      })}
    </>
  );
}
